module.exports = __webpack_public_path__ + "images/events-placeholder-1.jpg";